import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer" data-testid="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <span className="logo">
              Berenice <span className="accent">Sin Filtro</span>
            </span>
            <p>
              Escribo sobre emociones, vida cotidiana y viajes. Sin filtro.
            </p>
            <Link to="/newsletter" className="btn btn-accent btn-sm" data-testid="footer-cta-suscribirse">
              Recibir las cartas
            </Link>
          </div>
          <div className="footer-col">
            <h5>Escritos</h5>
            <ul>
              <li><Link to="/escritos">Archivo</Link></li>
              <li><Link to="/escritos">Por categoría</Link></li>
              <li><a href="/#populares">Lo más leído</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h5>Blog</h5>
            <ul>
              <li><Link to="/sobre-mi">Sobre mí</Link></li>
              <li><Link to="/newsletter">Newsletter</Link></li>
              <li><a href="mailto:hola@berenice-sinfiltro.blog">Contacto</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h5>Redes</h5>
            <ul>
              <li><a href="https://instagram.com/berenicebmx" target="_blank" rel="noreferrer" data-testid="footer-instagram">Instagram</a></li>
              <li><a href="#" target="_blank" rel="noreferrer">Substack</a></li>
              <li><a href="#" target="_blank" rel="noreferrer">Goodreads</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© 2025 Berenice — Sin Filtro</span>
          <span>Hecho a mano, sin prisa</span>
        </div>
      </div>
    </footer>
  );
}
